// extracted by mini-css-extract-plugin
export default {"container":"PageNavigation__container-Tkl5h"};